<template>
  <SettingsWrapper @close="$emit('close')" @save="save">
    <div class="divide-y divide-gray-200 p-6 px-8 py-0">
      <div class="flex justify-between items-center">
        <div>
          <h3 class="text-lg font-medium leading-6 text-gray-900">Arrives Today Shipping</h3>
          <p class="max-w-2xl text-sm text-gray-500 mt-1">If selected, orders will arrive on the same day it was created, with a higher price.</p>
        </div>
        <Toggle v-model="$v.active.$model"/>
      </div>
      <div
        class="mt-6"
        :class="$v.active.$model ? 'opacity-100' : 'opacity-60 pointer-events-none'"
      >
        <span class="text-sm text-gray-600 pt-6 inline-block">
          This method will only be shown between <span class="font-bold">{{ start.hour }}:{{ start.min }}</span> and <span class="font-bold">{{ end.hour }}:{{ end.min }}</span>.
        </span>

        <div class="flex space-x-5 pt-2">
          <div class="grow">
            <label for="host" class="block text-sm font-medium text-gray-700">Shipping cost</label>
            <div class="mt-1  w-full">
              <input type="text" v-model="$v.cost.$model" placeholder="0.00" name="shipping-cost" id="shipping-cost" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            </div>
          </div>
          <div class="shrink-0 w-[16rem]">
            <label for="host" class="block text-sm font-medium text-gray-700">Time Limit(Start)</label>
            <div class="mt-1 w-full flex">
              <select style="appearance: none;-webkit-appearance: none;-moz-appearance: none;" v-model="start.hour" class="block w-full shadow-sm focus:z-10 relative rounded-l-md border-gray-300 focus:border-blue-500 text-gray-900 focus:ring-2 focus:ring-blue-500 sm:text-sm ">
                <option v-for="(e, num) in Array(24)" :value="num" :key="num" :selected="start.hour === num">
                  {{ num }}  hours
                </option>
              </select>
              <select style="appearance: none;-webkit-appearance: none;-moz-appearance: none;" v-model="start.min" class="block w-full shadow-sm focus:z-10 relative rounded-r-md border-l-0 border-gray-300 focus:border-blue-500 text-gray-900 focus:ring-2 focus:ring-blue-500 sm:text-sm ">
                <option v-for="(e, num) in Array(59)" :value="num" :key="num" :selected="start.min === num">
                  {{ num }} minutes
                </option>
              </select>
            </div>
          </div>
          <div class="shrink-0 w-[16rem]">
            <label for="host" class="block text-sm font-medium text-gray-700">Time Limit(End)</label>
            <div class="mt-1 w-full flex">
              <select style="appearance: none;-webkit-appearance: none;-moz-appearance: none;" v-model="end.hour" class="block w-full shadow-sm focus:z-10 relative rounded-l-md border-gray-300 focus:border-blue-500 text-gray-900 focus:ring-2 focus:ring-blue-500 sm:text-sm ">
                <option v-for="(e, num) in Array(24)" :value="num" :key="num" :selected="end.hour === num">
                  {{ num }}  hours
                </option>
              </select>
              <select style="appearance: none;-webkit-appearance: none;-moz-appearance: none;" v-model="end.min" class="block w-full shadow-sm focus:z-10 relative rounded-r-md border-l-0 border-gray-300 focus:border-blue-500 text-gray-900 focus:ring-2 focus:ring-blue-500 sm:text-sm ">
                <option v-for="(e, num) in Array(59)" :value="num" :key="num" :selected="end.min === num">
                  {{ num }} minutes
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SettingsWrapper>
</template>

<script>

import SettingsWrapper from "./SettingsWrapper"
import Toggle from "./Inputs/Toggle"

import websitePropertiesHelper from "@/components/SideEditor/website-properties-helper"

export default {
  components: {
    SettingsWrapper,
    Toggle,
  },
  data() {
    return {
      start: { hour: 10, min: 30 },
      end: { hour: 19, min: 30 },
    }
  },
  created() {
    this.$v.startLimit.$model = this.startTime
    this.$v.endLimit.$model = this.endTime
  },
  mixins: [
    websitePropertiesHelper({
      success: "Successfully saved shipping settings!",

      key: "arrives-today-shipiping",
      fieldMap: {
        active: "carriers/arrivestoday/active",
        cost: "carriers/arrivestoday/shipping_cost",
        startLimit: "carriers/arrivestoday/starttime",
        endLimit: "carriers/arrivestoday/endtime",
      },
      prepare: {
        cost: val => (val + '').replace(',', '.'),
      },
    }),
  ],
  computed: {
    startTime() {
      return `${this.start.hour},${this.start.min},00`
    },
    endTime() {
      return `${this.end.hour},${this.end.min},00`
    },
  },
  watch: {
    startTime(val) {
      this.$v.startLimit.$model = val
    },
    endTime(val) {
      this.$v.endLimit.$model = val
    },
  },
}

</script>
